const messages = {
    pt: {
        translations: {
            navbar: {
                privateContact: 'CONTATO PARTICULAR',
                home: 'Home',
                about: 'Sobre',
                skills: 'Habilidades',
                projects: 'Projetos',
                contact: 'Contato'
            },

            initial: {
                wellcome: 'Seja bem-vindo, eu sou',
                h1: 'Gabriel Gonçalves Cunha',
                h2: 'Desenvolvedor',
                em: 'front end.',
                p: 'Criando interfaces eficientes e otimizadas'
            },

            presentation: {
                about: 'SOBRE',
                about_text1: 'Estou disposto a fazer dar certo o que esta em minhas mãos dentro do meu melhor.',
                address: 'MORA EM',
                address_text1: 'São Paulo',
                address_text2: 'São Paulo',
                address_text3: 'Brasil',
                experience: 'EXPERIÊNCIA',
                experience_text: '2 - 5 anos | Pleno (mid)',
                frase: 'a',
                download: 'DOWNLOAD',
                download_button: 'Profile.pdf'
            },

            skills: {
                focus: 'Foco e skills',
                p: 'Meu foco é entregar resultados. Minhas principais áreas de especialização incluem: Desenvolvimento de websites responsivos e rápidos com design profissional. Criação de e-commerce otimizadas para conversão. Desenvolvimento de landing pages estratégicas para campanhas e lançamentos. Otimização de SEO para aumentar a visibilidade no Google. Manutenção especializada de websites e suporte técnico. ',

                development_desc: 'Desenvolvimento de aplicações modernas e rápidas, utilizando componentes reutilizáveis para garantir escalabilidade.',
                design_desc: 'Criação de interfaces intuitivas e profissionais, focadas na experiência do usuário e na fidelidade visual.',
                marketing_desc: 'Otimização para o Google (SEO) e infraestrutura em nuvem para garantir que o site suporte acessos e carregue instantaneamente.',
                workflow_desc: 'Uso de fluxos de trabalho organizados e controle de versão para garantir a segurança do código e entregas constantes.'
            },

            projects: {
                project: 'PROJETOS',
                development: 'Desenvolvimentos e participações',
                seemore: 'Ver mais',
                text_dev:'Nesses projetos, fui responsável pelo desenvolvimento do frontend de mais de 45 lojas, trabalhando em conjunto com o time ',
                modal_button: 'Fechar',
                modal_warning: 'O site pode não estar disponível devido a administração do cliente. Atualizado em 04-07-2022*',
                modal_warning2: 'O site pode não estar disponível devido a administração do cliente. Atualizado em 18-12-2025*'
            },

            contact: {
                send: 'Envie um e-mail para',
                follow: 'SIGA'
            },
        }
    }
}

export { messages }